<template>
	<article class="question">
		<div class="site-wrapper rythm-v">
			<header>
				<h1>Éditer la référence</h1>
				<p>
					<em><strong>Question</strong> &quot;{{ question.title }}&quot;</em>
				</p>
			</header>

			<div class="section--questions rythm-v">
				<div class="toolbar">
					<router-link
						:to="`/question/${questionID}`"
						class="button--outline"
					>
						<svg
							role="img"
							class="icon"
							xmlns="http://www.w3.org/2000/svg"
							width="16"
							height="16"
							viewBox="0 0 16 16"
						>
							<path
								fill="currentColor"
								d="M7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071C9.09763 15.3166 9.09763 14.6834 8.70711 14.2929L3.41421 9L15 9C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7L3.41421 7L8.70711 1.70711C9.09763 1.31658 9.09763 0.683418 8.70711 0.292894C8.31658 -0.0976312 7.68342 -0.0976312 7.29289 0.292894L0.292894 7.29289C-0.0976312 7.68342 -0.0976312 8.31658 0.292894 8.70711L7.29289 15.7071Z"
							/>
						</svg>
						<span class="caption">Retour</span></router-link>
				</div>

				<div class="card shadow">
					<form @submit.prevent="handleSubmit">
						<div class="form-wrapper">
							<div class="input-group required">
								<label for="title">Titre&nbsp;:</label>
								<input
									type="text"
									id="title"
									name="title"
									v-model="title"
									required
								/>
							</div>

							<div class="editor-reference">
								<vue-editor
									id="editor1"
									v-model="editors.reference.content"
									:editor-toolbar="editors.reference.toolbar"
								/>
							</div>

							<div class="editor-authors">
								<p class="label">Auteurs, sources, liens&nbsp;:</p>
								<vue-editor
									id="editor2"
									v-model="editors.authors.content"
									:editor-toolbar="editors.authors.toolbar"
								/>
							</div>

							<div class="input-group-controls flex-row flex-align-right">
								<button
									class="button--primary"
									type="submit"
								>
									<svg
										class="icon"
										role="img"
										xmlns="http://www.w3.org/2000/svg"
										width="22"
										height="22"
										fill="none"
										viewBox="0 0 22 22"
									>
										<path
											fill="currentColor"
											fill-rule="evenodd"
											d="M21.7071 0.292921C22.0976 0.683445 22.0976 1.31661 21.7071 1.70713L10.7071 12.7071C10.3166 13.0977 9.68342 13.0977 9.2929 12.7071C8.90237 12.3166 8.90237 11.6834 9.2929 11.2929L20.2929 0.292921C20.6834 -0.0976032 21.3166 -0.0976032 21.7071 0.292921Z"
											clip-rule="evenodd"
										/>
										<path
											fill="currentColor"
											fill-rule="evenodd"
											d="M21.7071 0.292921C21.9787 0.564559 22.0708 0.967791 21.9439 1.33038L14.9439 21.3304C14.8084 21.7174 14.4504 21.9825 14.0408 21.9992C13.6311 22.0159 13.2527 21.7808 13.0862 21.4062L9.2424 12.7576L0.593867 8.91384C0.219186 8.74731 -0.0158775 8.36894 0.000836285 7.95926C0.0175501 7.54959 0.282654 7.19162 0.669655 7.05617L20.6697 0.0561695C21.0322 -0.0707359 21.4355 0.0212832 21.7071 0.292921ZM3.71108 8.11063L10.4061 11.0862C10.6324 11.1868 10.8133 11.3677 10.9138 11.5939L13.8894 18.289L19.37 2.63L3.71108 8.11063Z"
											clip-rule="evenodd"
										/>
									</svg>
									<span class="caption">Enregistrer</span>
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</article>
</template>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";
@import "~quill/dist/quill.core.css";
</style>

<style lang="scss" scoped>
.form-wrapper > * + * {
	margin-top: 2rem;
}

.editor-reference {
	height: 36rem;
}

.label {
	margin-bottom: 1rem;
}

.quillWrapper {
	align-content: flex-start;
	align-items: flex-start;
	display: flex;
	flex-flow: column nowrap;
	flex-grow: 1;
	justify-content: flex-start;
	height: 100%;

	& > * {
		width: 100%;
	}

	.ql-editor {
		background-color: white;
	}
}
</style>

<script>
// https://www.vue2editor.com/guide.html#usage
import { VueEditor } from "vue2-editor";

export default {
	name: "referenceEdit",

	props: ["questionID", "refID"],
	components: { VueEditor },

	data: function() {
		return {
			question: {},
			title: null,

			editors: {
				reference: {
					content: null,
					toolbar: [
						[{ header: [false, 2, 3, 4, 5, 6] }],
						["bold", "italic", "underline", "strike"], // toggled buttons
						[{ list: "ordered" }, { list: "bullet" }],
						[{ script: "sub" }, { script: "super" }], // superscript/subscript
						// [{align: []}],
						["link"],
						["clean"]
						// ["blockquote", "code-block"],
						// [{header: 1}, {header: 2}], // custom button values
						// [{indent: "-1"}, {indent: "+1"}], // outdent/indent
						// [{direction: "rtl"}], // text direction
						// [{size: ["small", false, "large", "huge"]}], // custom dropdown
						// [{color: []}, {background: []}], // dropdown with defaults from theme
						// [{font: []}],
					]
				},
				authors: {
					content: null,
					toolbar: [
						["bold", "italic", "underline", "strike"], // toggled buttons
						[{ list: "ordered" }, { list: "bullet" }],
						["link"],
						["clean"]
					]
				}
			}
		};
	},

	computed: {
		// Current user data
		user: function() {
			return this.$store.state.userData;
		},

		// Is the user a coordinator? (role 3)
		user_is_coordinator: function() {
			return this.user.roles.indexOf(3) !== -1;
		},

		// Is the user an expert? (role 2)
		user_is_expert: function() {
			return this.user.roles.indexOf(2) !== -1;
		}
	},

	methods: {
		// TODO: save with user_id
		handleSubmit: function(event) {
			let data = {
				question_id: this.questionID,
				title: this.title,
				content: this.editors.reference.content,
				authors: this.editors.authors.content
			};

			this.$store
				.dispatch("POST_REFERENCE", data)
				.then(response => {
					this.referenceID = response;
					this.$router.push(`/question/${this.questionID}`);
				})
				.catch(error => {
					console.log("POST_REFERENCE error…", error);
				});
		},

		// Load reference
		getReference: function() {
			let refID = this.refID;

			this.$store
				.dispatch("GET_REFERENCE", refID)
				.then(response => {
					this.title = response.title;
					this.editors.reference.content = response.content;
					this.editors.authors.content = response.authors;
				})
				.catch(error => {
					console.log("getReference error…", error);
					// eventHub.$emit("network-error", error.response);
				});
		},

		// Load question
		getQuestion: function() {
			this.$store
				.dispatch("GET_QUESTION_DATA", this.questionID)
				.then(response => {
					this.question = response;
				})
				.catch(error => {
					console.log("getQuestion error…", error);
					// eventHub.$emit("network-error", error.response);
				});
		}
	},

	mounted() {
		// Load question and reference
		if (this.questionID > 0) this.getQuestion();
		if (this.refID > 0) this.getReference();
	}
};
</script>
